import { z } from 'zod'
import { api } from '../http'
import { JobSchema } from '../schemas'

// Rust owns the configuration schema and normalization. Transport the reviewed
// document intact; the browser never constructs runtime pins or host paths.
const ConfigurationSchema = z.record(z.unknown())
export const SurroundingsReviewSchema = z.object({
  schemaVersion: z.literal(1),
  reviewId: z.string().regex(/^[a-f0-9]{64}$/),
  form: z.object({
    configuration: ConfigurationSchema,
    products: z.record(z.boolean()),
    creditLimits: z.object({
      cleanup: z.number(),
      grassSegmentation: z.number(),
    }),
    export: z.object({
      forestRadiusM: z.number().nullable(),
      nearFarRadiusM: z.number().nullable(),
      grassQualityRadiusM: z.number().nullable(),
      vehicleScope: z.string(),
    }),
  }),
  creditEstimate: z.literal('awaiting_source_plan'),
})
const SubmittedSchema = z.object({ runId: z.string().uuid(), data: JobSchema })
const RecoverySchema = SurroundingsReviewSchema.omit({
  creditEstimate: true,
}).extend({
  runId: z.string().uuid(),
  previousJobId: z.string().uuid(),
})
export const reviewSurroundingsRecovery = (runId: string) =>
  api.post(
    `/surroundings/runs/${encodeURIComponent(runId)}/resume/review`,
    {},
    RecoverySchema,
  )
export const resumeSurroundings = (
  runId: string,
  body: { idempotencyKey: string; reviewId: string },
) =>
  api.post(
    `/surroundings/runs/${encodeURIComponent(runId)}/resume`,
    body,
    SubmittedSchema,
  )
const HistorySchema = z.array(
  z.object({
    runId: z.string().uuid(),
    jobId: z.string().uuid(),
    status: z.string(),
    projectName: z.string(),
    location: z.discriminatedUnion('kind', [
      z.object({
        kind: z.literal('coordinates'),
        latitude: z.number(),
        longitude: z.number(),
        label: z.string(),
      }),
      z.object({ kind: z.literal('address'), address: z.string() }),
    ]),
  }),
)
export const listSurroundings = () =>
  api.get('/surroundings/runs', HistorySchema)
const DownloadSchema = z.object({
  url: z.string().url(),
  sha256: z.string().regex(/^[a-f0-9]{64}$/),
  sizeBytes: z.number().nonnegative(),
  expiresInSeconds: z.number().positive(),
})

export const surroundingsProfile = () =>
  api.get('/surroundings/profile', SurroundingsReviewSchema)
export const reviewSurroundings = (configuration: Record<string, unknown>) =>
  api.post('/surroundings/review', { configuration }, SurroundingsReviewSchema)
export const generateSurroundings = (body: {
  idempotencyKey: string
  reviewId: string
  configuration: Record<string, unknown>
}) => api.post('/surroundings/runs', body, SubmittedSchema)
export const downloadSurroundings = (runId: string) =>
  api.get(
    `/surroundings/runs/${encodeURIComponent(runId)}/download`,
    DownloadSchema,
  )
